var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export const setLoggedInListeners = ({ authService, mode, privateDispatch }) => {
    window.addEventListener('storage', (change) => __awaiter(this, void 0, void 0, function* () {
        const { key, oldValue, newValue } = change;
        if (key === 'isLoggedIn' && oldValue !== newValue) {
            console.log('isLoggedIn changed to', newValue, typeof newValue);
            if (newValue === 'true') {
                privateDispatch({ type: 'GLOBAL_LOGIN_DETECTED' });
            }
            else if (newValue === 'false') {
                if (mode === 'legacy2019')
                    privateDispatch({ type: 'LOGOUT', message: 'Logout detected from another window' });
            }
            else {
                console.warn('unexpected value for localStorage.isLoggedIn', newValue);
            }
        }
    }));
};
